import { getStageHeat } from '../trackingUtils';
import type { StageSummary } from '../types';

const StageHeat = ({ stage }: { stage: StageSummary }) => {
    const heat = getStageHeat(stage);
    return (
        <span className='mt-heat'>
            <i className={heat.tone} style={{ width: `${heat.width}%` }} />
        </span>
    );
};

export default StageHeat;
